import {Model} from "ords/dist/model/model";

class AssignmentCooperation extends Model {
    getAssignmentPartnerForUser(user_id) {
        return this.assignment_partners.find((assignmentPartner) => {
            return assignmentPartner.assignment_partner_users.some((assignmentPartnerUser) => assignmentPartnerUser.id === user_id)
        })
    }
}

export const AssignmentCooperationModelConfig = {
    name: 'assignmentCooperation',
    model: AssignmentCooperation,
    relations: [
        {name: 'assignment_partners', model_name: 'assignmentPartner', type: 'hasMany'},
    ]
}
